<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <polyline
      points="6.15 9.5 11.82 13.15 19.01 8.54"
      fill="none"
      fill-rule="evenodd"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-width="1.5"
    />
    <circle cx="12" cy="11.96" r="11.17" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="1.5" />
  </svg>
</template>
